import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { selectPersistStateInit } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { AuthQuery } from '../store/auth';

@Injectable({ providedIn: 'root' })
export class LoginGuard {
  private authQuery = inject(AuthQuery);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([this.authQuery.loggedIn$, selectPersistStateInit()]).pipe(
      map(([isLoggedIn]) => {
        if (isLoggedIn) {
          this.router.navigate(['/dashboard/bookings']);
          return false;
        }
        return true;
      })
    );
  }
}
